export const REGISTRATION_ASSET_TYPE_ID = 108;
export const ZORGAANBIEDERS_PORTAAL_ID = 8;
export const VERPLEEGKUNDIG_SPECIALISTEN_ID = 7;
